import { useState, useEffect, useCallback } from 'react';
import { gameLogger, LogLevel, LogEntry } from '../../../utils/GameLogger';

export function useLogViewerState(isVisible: boolean) {
  const [logs, setLogs] = useState<LogEntry[]>([]);
  const [filter, setFilter] = useState({ level: LogLevel.DEBUG, category: '', search: '' });
  const [stats, setStats] = useState<any>(null);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const refreshLogs = useCallback(() => {
    let filteredLogs = gameLogger.getLogs().filter(log =>
      log.level >= filter.level && (!filter.category || log.category === filter.category)
    );

    if (filter.search) {
      const searchLower = filter.search.toLowerCase();
      filteredLogs = filteredLogs.filter(log =>
        log.message.toLowerCase().includes(searchLower) ||
        (log.data && JSON.stringify(log.data).toLowerCase().includes(searchLower)) ||
        (log.category && log.category.toLowerCase().includes(searchLower))
      );
    }

    setLogs(filteredLogs.slice(-150));
    setStats(gameLogger.getLogStats());
  }, [filter]);

  useEffect(() => {
    if (!isVisible) return undefined;
    refreshLogs();
    if (autoRefresh) {
      const interval = setInterval(refreshLogs, 1000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [isVisible, refreshLogs, autoRefresh]);

  return {
    logs,
    filter,
    setFilter,
    stats,
    autoRefresh,
    setAutoRefresh,
    refreshLogs
  };
}
